import { getCookies, setPermanentCookie } from '~/store/cookies.js';

const COOKIE = 'd_id';

const tempSessionIdGetter = () => {
	try {
		if (!getCookies(COOKIE)) {
			const uuid = window.crypto.randomUUID();
			const expireDate = new Date();
			expireDate.setFullYear(expireDate.getFullYear() + 1);
			setPermanentCookie(COOKIE, uuid, expireDate);
		}
		return getCookies(COOKIE);
	} catch (err) {
		// eslint-disable-next-line no-console
		console.warn(err);
		return '';
	}
};

export default tempSessionIdGetter;
